import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import { TemplateOptionListRequest, TemplateOptionListResponse } from "./types";

export const templateOptionListService = (params: TemplateOptionListRequest) =>
  RestAPIClient.call<TemplateOptionListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.OptionList,
    config: {
      params,
      requireAuthentication: true,
    },
  });
